import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/organizations/$organizationId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/organizations/$organizationId/supply-points',
      params,
      replace: true,
    });
  },
});
